import { render } from "./SubscriptionBtn.vue?vue&type=template&id=963c7f1c"
import script from "./SubscriptionBtn.vue?vue&type=script&lang=js"
export * from "./SubscriptionBtn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__